module.exports = __webpack_public_path__ + "static/img/video2.a88b77f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/video2.jpg
// module id = SIKV
// module chunks = 0